import React from 'react';
import { useInView } from '@/hooks/useInView';

/**
 * Reveal — fade an element into view with a chosen direction when it scrolls in.
 *
 *   <Reveal direction="up" delay={120}>...</Reveal>
 *
 * Directions:
 *   - up    (default) — fade + translateY up
 *   - left           — fade + slide from left
 *   - right          — fade + slide from right
 *   - scale          — fade + scale-in (springy)
 *   - rotate         — fade + slight rotation (playful, for testimonials)
 */
const ANIM = {
  up: 'bb-anim-fade-up',
  left: 'bb-anim-fade-left',
  right: 'bb-anim-fade-right',
  scale: 'bb-anim-scale-in',
  rotate: 'bb-anim-rotate-in',
};

export const Reveal = ({
  children,
  as: Tag = 'div',
  delay = 0,
  direction = 'up',
  className = '',
  ...rest
}) => {
  const { ref, inView } = useInView();
  const animClass = ANIM[direction] || ANIM.up;
  return (
    <Tag
      ref={ref}
      className={`${className} ${inView ? animClass : 'opacity-0'}`}
      style={{ animationDelay: inView ? `${delay}ms` : undefined }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
